import { Injectable } from '@angular/core';
import { Answer } from '../model/answer';
import { AVAILABLE_ANSWERS, Y_N_ANSWER } from '../constants';

@Injectable()
export class AnswerService {

  constructor() { }

  answers(): Answer[] {
    return AVAILABLE_ANSWERS;
  }

  defaultAnswer(): Answer {
    return Y_N_ANSWER;
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/answer.service.ts